import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['badge']
  static values = {
    cycleId: Number
  }

  connect() {
    this.sidebarOpen = false

    window.addEventListener('galette:sidebar:close', this.handleSidebarClosed)
    window.addEventListener('galette:sidebar:open', this.handleSidebarOpened)
    window.addEventListener('galette:sidebar:update-content', this.handleSidebarOpened)
    document.addEventListener('reporting-cycle:comment-added', this.handleCommentAdded)
  }

  disconnect() {
    window.removeEventListener('galette:sidebar:close', this.handleSidebarClosed)
    window.removeEventListener('galette:sidebar:open', this.handleSidebarOpened)
    window.removeEventListener('galette:sidebar:update-content', this.handleSidebarOpened)
    document.removeEventListener('reporting-cycle:comment-added', this.handleCommentAdded)
  }

  handleSidebarClosed = () => {
    this.sidebarOpen = false
    this.reloadFrame()
  }

  handleSidebarOpened = event => {
    // Only set sidebarOpen if the Comments sidebar opened
    const url = event.detail?.url
    const isCommentsSidebar = url && url.includes('/comments?')

    if (isCommentsSidebar) {
      this.sidebarOpen = true
      this.updateBadgeVisibility()
    }
  }

  handleCommentAdded = event => {
    if (event.detail.cycle_id === this.cycleIdValue && !this.sidebarOpen) {
      this.reloadFrame()
    }
  }

  reloadFrame() {
    const frame = this.element.closest('turbo-frame')
    if (frame && frame.src) {
      frame.reload()
    }
  }

  updateBadgeVisibility() {
    if (!this.hasBadgeTarget) return

    if (this.sidebarOpen) {
      this.badgeTarget.classList.add('d-none')
    } else {
      this.badgeTarget.classList.remove('d-none')
    }
  }
}
